<div id="subscribers-list">

  <ng-container *ngIf="isInitialized">
    <ul *ngIf="subscribers && subscribers.length > 0" class="widget__list" style="margin-bottom: 15px;">
      <li *ngFor="let subscriber of subscribers | paginate: { id: 'subscribers', itemsPerPage: pagination.pageSize, currentPage:
  p, totalItems: pagination.total }" class="widget__list__item">
        <span class="widget__list__title">{{ subscriber.email }}</span>
        <span class="widget__list__actions">
          <a [routerLink]="['subscribers/edit', subscriber.id]" class="widget__list__actions__link widget__list__actions__link--edit">
            <i class="ico-edit"></i>
          </a>
          <a [routerLink]="{ outlets: { 'modal': ['subscribers-delete', subscriber.id] } }" [queryParams]="{header:'Opravdu chcete smazat odběratele ' + subscriber.email + '?', body: 'Uživatele již nebude možné obnovit.'}"
            class="widget__list__actions__link widget__list__actions__link--remove">
            <i class="ico-remove"></i>
          </a>
        </span>
      </li>
    </ul>
  </ng-container>
  <pagination-controls *ngIf="pagination.pageSize > 0" id="subscribers" (subscriberChange)="pageChanged($event)" maxSize="9" directionLinks="true" autoHide="true"
    previousLabel="" nextLabel="" screenReaderPaginationLabel="Pagination" screenReaderPageLabel="Stránka" screenReaderCurrentLabel="Jste na stránce">
  </pagination-controls>


  <div *ngIf="!isInitialized" class="widget__content loading"></div>

  <swb-no-data *ngIf="subscribers && subscribers.length === 0 && isInitialized"></swb-no-data>

</div>